import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.QBooks.QBooksTaxSwitcher', {
    taxRateLabel: 'Tax Rate',
    taxRatePlaceholder: 'Select Tax Rate',
    discountLabel: 'Discount',
    discountPlaceholder: 'Enter discount',
    discountTypePercent: 'Discount percent',
    discountTypeAmount: 'Discount value',
    basedOnLocation: 'Based on location',
    basedOnLocationTooltip: `
        Once your invoice is approved and submitted to QuickBooks Online,
        automated tax calculations will be performed.`,
});
